'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSettings = function IoSettings(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.9 10.8c0.8 0.5 1.2 1.9 1.1 2.8-0.1 1.3-0.5 2.8-2 4.2 0 0.1-0.1 0.1-0.2 0.2-2 1.9-4.8 2.3-7.3 1.5-0.1 0-0.2-0.1-0.3-0.1-0.4-0.1-0.8 0-1.1 0.3l-2.8 3c4.1 3.9 8.4 7.5 8.4 7.5 0.1 0.2 0.1 0.4 0 0.6l-3.9 4c-0.2 0.1-0.4 0.1-0.6 0 0 0-3.4-4.3-7.2-8.4l-7.2 7.7c-1.1 1.2-3.1 1.1-4.3 0-1.2-1.3-1.2-3.3 0.1-4.4l7.5-7.3-0.9-0.9c-0.2-0.2-0.2-0.6-0.1-0.8l0.2-0.4c-2-2-2.8-2.6-4.4-2.5s-2.8 1-3.7 2.2-0.8 4.1-0.7 4.8-0.5 0.5-0.9 0c-0.7-0.7-1.8-3.9-0.5-7.2s3.3-5.4 3.8-5.9 1.2-1.2 1.8-1.6 1.7 0.1 2.2-0.4c0.3-0.3 0.3-0.9 0.3-1.3l-0.3-0.3c-0.1-0.1-0.1-0.4 0-0.5l2.5-2.4c0.1-0.2 0.3-0.2 0.5 0l3.9 3.9c0.2 0.1 0.2 0.4 0 0.6l-2.4 2.4c-0.2 0.2-0.4 0.2-0.6 0l-0.6-0.7c-0.5 0-1.2 0.4-1.3 0.8-0.2 0.5-0.5 1.6-0.2 2.6 0.2 0.8 1 1.5 2.8 3.3l0.4-0.2c0.3-0.2 0.6-0.1 0.7 0.1 0 0 0.1 0.1 1.1 1.1l2.9-2.9c0.3-0.3 0.4-0.6 0.3-1 0-0.2 0-0.4 0-0.4-0.8-2.6-0.5-5.4 1.4-7.5l0.2-0.2c1.4-1.4 2.8-1.9 4.1-2 0.8-0.1 2.4 0.4 2.8 1.1l-3.8 3.8-0.1 0.2-0.1 0.1c-0.1 0.1-0.1 0.2-0.1 0.3s0 0.3 0.1 0.4l0.3 0.3 3.2 3.3 0.3 0.3c0.1 0.1 0.2 0.1 0.3 0.1s0.3 0 0.3-0.1l0.2-0.1 0.2-0.2z' })
        )
    );
};

exports.default = IoSettings;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/settings.js
// module id = 2437
// module chunks = 0